<template>
  <modal-form v-model="show" :submit="submit" size="xl">
    <template v-slot:title> Incluir Assinante </template>
    <template v-slot:body>
      <v-row>
        <v-col cols="11">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" small v-on="on" @click="novoAssinante">
                <v-icon class="mr-2" small>fa-solid fa-plus</v-icon>Novo</v-btn
              >
            </template>
            <span>Novo Assinante</span>
          </v-tooltip>
          <v-btn
            class="float-right"
            v-if="dadosPJ.length !== 0"
            color="primary"
            small
            outlined
            @click="importaAssinantes"
          >
            <v-icon small class="mr-2">fas fa-upload</v-icon>
            Importar Assinantes dos Garantidores PJ
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-for="(item, i) in model" :key="i">
        <v-col cols="2">
          <input-text v-model="item.Nome" label="Nome" required />
        </v-col>
        <v-col cols="2">
          <input-documento
            v-model="item.DocumentoFederal"
            cpf
            label="CPF"
            required
            :rules="() => validaDocumento(item)"
          />
        </v-col>
        <v-col cols="2">
          <input-email v-model="item.Email" label="E-mail" required />
        </v-col>
        <v-col cols="2">
          <input-phone v-model="item.Telefone" label="Celular" cel required />
        </v-col>
        <v-col cols="3">
          <input-multiselect
            :options="arrayPapeis()"
            v-model="item.Papeis"
            label="Papéis"
            required
          >
            <template v-slot:selection="{ index }">
              <v-chip v-if="index === 0" class="mr-2" label outlined>
                {{
                  item.Papeis.length +
                  (item.Papeis.length === 1
                    ? " papel selecionado"
                    : " papéis selecionados")
                }}
              </v-chip>
            </template>
          </input-multiselect>
        </v-col>
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="mt-4 ml-2"
                icon
                @click="model.splice(i, 1)"
                data-cy-action="bound deletar"
              >
                <v-icon color="red" medium> ph-trash </v-icon>
              </v-btn>
            </template>
            <span>Excluir Assinante</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </template>
  </modal-form>
</template>
<script>
export default {
  props: {
    codigoProposta: { type: String, default: null },
    proposta: null,
    isCCBEletronica: null
  },
  data () {
    return {
      show: false,
      model: [{}],
      dadosPJ: [],
      dadosAva: [],
    };
  },
  methods: {
    openModal () {
      const th = this;
      th.show = true;
      th.model = [{}];
      th.dadosPJ = [];
      const dto = {
        parameters: [{ name: 'CodigoProposta', value: th.codigoProposta }],
      };
      th.$api.Multiplo.ListPropostaAvalista(dto).then(function (
        response
      ) {
        const isPJ = response.Data.find(
          (p) => p.DocumentoFederal.length === 14
        );
        if (isPJ) {
          response.Data.forEach((p) => {
            th.$api.Multiplo.FindRecordPropostaAvalista({
              guidID: p.Codigo,
            }).then(function (responseAva) {
              if (responseAva.PropostaAvalistaPJ) {
                th.dadosAva.push(responseAva);
                th.dadosPJ.push(responseAva.PropostaAvalistaPJ);
              }
            });
          });
        }
      });
    },
    novoAssinante () {
      this.model.push({});
    },
    importaAssinantes () {
      const th = this;
      let count = 0;
      const arrayDocumentos = [];
      if (Object.keys(th.model[0]).length === 0) {
        th.dadosPJ.forEach((p, index) => {
          const papelSocio =
            `Representante Legal - Empresa ${th.dadosAva[index].Nome} - ${th.dadosAva[index].DocumentoFederal}`
              .substring(0, 100)
              .toUpperCase();
          for (let i = 1; i < 6; i++) {
            if (p[`Socio${i}Documento`]) {
              const DocumentoFederal = p[`Socio${i}Documento`];
              const Nome = p[`Socio${i}Nome`];
              if (count === 0) {
                count++;
                th.$set(th.model[0], 'Nome', Nome);
                th.$set(th.model[0], 'DocumentoFederal', DocumentoFederal);
                th.$set(th.model[0], 'Papeis', [papelSocio]);
              } else {
                th.model.push({
                  Nome: Nome,
                  DocumentoFederal: DocumentoFederal,
                  Papeis: [papelSocio],
                });
              }
            }
          }
        });
      } else {
        th.model.forEach((p) => {
          arrayDocumentos.push(p.DocumentoFederal);
        });
        th.dadosPJ.forEach((l, index) => {
          const papelSocio =
            `Representante Legal - Empresa ${th.dadosAva[index].Nome} - ${th.dadosAva[index].DocumentoFederal}`
              .substring(0, 100)
              .toUpperCase();
          for (let i = 1; i < 6; i++) {
            if (
              l[`Socio${i}Documento`] &&
              !arrayDocumentos.includes(l[`Socio${i}Documento`])
            ) {
              th.model.push({
                Nome: l[`Socio${i}Nome`],
                DocumentoFederal: l[`Socio${i}Documento`],
                Papeis: [papelSocio],
              });
            }
          }
        });
      }
    },
    submit () {
      const th = this;
      const arrayIncluir = [];
      const arrayExistentes = [];
      var dto = {
        parameters: [
          { name: 'CodigoProposta', value: this.codigoProposta },
          { name: 'search', value: '' },
        ],
      };
      th.$api.Multiplo.ListCCBDigitalAssinatura(dto).then(function (
        assinantes
      ) {
        if (th.$api.UI.PostLoadData(assinantes, true)) {
          assinantes = assinantes.Data;
          th.model.forEach((p) => {
            p.Papeis.forEach((z) => {
              const item = assinantes.find(
                (l) =>
                  l.Documento ===
                    th.$api.UI.Format.SomenteNumeros(p.DocumentoFederal) &&
                  (typeof z === 'string'
                    ? z.toUpperCase() === l.Descricao
                    : z === l.PapelID)
              );
              if (item) {
                arrayExistentes.push(item);
              } else {
                th.$api.Multiplo.FindRecordProdutoRede().then(function (res) {
                  const dto = {
                    CodigoProposta: th.codigoProposta,
                    Nome: p.Nome,
                    Email: p.Email,
                    Documento: th.$api.UI.Format.SomenteNumeros(
                      p.DocumentoFederal
                    ),
                    TelefoneCelular: p.Telefone,
                    NotificarPorEmail: th.isCCBEletronica && th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
                    NotificarPorWhatsApp: th.isCCBEletronica && th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
                  };
                  if (typeof z === 'string') {
                    dto.Descricao = z;
                  } else {
                    dto.PapelID = z;
                  }
                  arrayIncluir.push(dto);
                })
              }
            });
          });
          if (arrayExistentes.length !== 0) {
            th.$api.UI.Confirmacao(
              'info',
              (arrayExistentes.length === 1
                ? 'O papel abaixo já foi cadastrado e será ignorado:<br/>'
                : 'Os papéis abaixo já foram cadastrados e serão ignorados:<br/>') +
                arrayExistentes
                  .map(
                    (o) =>
                      'Documento: ' +
                      th.$api.UI.Format.DocumentoFederal(o.Documento) +
                      ' - ' +
                      'Papel: ' +
                      th.enumPapel(o)
                  )
                  .join('<br/>') +
                '<br/>Deseja prosseguir?',
              function () {
                th.incluir(arrayIncluir);
              },
              function () {
                th.$api.UI.ShowError(th.$getErrorMessage('operacao.cancelada.title'));
              },
              arrayExistentes.length === 1
                ? 'Papel Duplicado'
                : 'Papéis Duplicados'
            );
          } else {
            th.incluir(arrayIncluir);
          }
        }
      });
    },
    enumPapel (num) {
      const str = this.arrayPapeis().find((z) => z.value === num.PapelID);
      if (str) {
        return str.text;
      } else {
        return num.Descricao;
      }
    },
    incluir (arr) {
      const th = this;
      th.$api.Multiplo.InsertCCBDigitalAssinaturas({ dto: arr }).then(
        function (response) {
          if (th.$api.UI.PostAction(response, 'Assinantes atualizados')) {
            th.close();
          }
        }
      );
    },
    close () {
      this.show = false;
      this.$emit('carregarAssinantes');
    },
    arrayPapeis (model) {
      return this.$api.Estruturadas.listPapeis(
        this,
        this.$api.Estruturadas.TipoAssinanteEnum.Outros,
        model,
        this.proposta
      );
    },
    validaDocumento (item) {
      return [item.DocumentoFederal !== this.proposta.Cliente.DocumentoFederal || 'Documento do Assinante deve ser diferente do Emitente']
    }
  },
};
</script>
